import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import NavBarKS from "../../components/NavBarKS";
import moment from "moment";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import ProgressPaymentCard from "./ProgressPaymentCard";
import {Card, Row, Col, Input, Label, Nav, NavItem, NavLink, TabContent, TabPane, Button} from "reactstrap";
import ExcelExporter from "../../components/ExcelExporter";
import * as headerContent from "../../constants/exportcontent";
import HakedisList from "./HakedisList";
import PayTrList from "./PayTrList";
import {defterUnitName, showProgressPaymentFields} from "../../helper/permission";
import {Bar} from "react-chartjs-2";
import './ProggressPayment.css'
import PayTrPrefixList from "./PayTrPrefixList";
import {EntegratorConf, VirtualHost} from "../../constants";
import BayiList from "./BayiList";
import TopluKontorList from "./TopluKontorList";



class ProgressPaymentList extends Component {
	constructor(props) {
		super(props);
		const storedIsActive = localStorage.getItem("isActive");
		const isActive = storedIsActive !== null ? JSON.parse(storedIsActive) : props.isActive;
		localStorage.setItem("isActive", JSON.stringify(isActive));
		this.state = {
			manual: false,
			content: [],
			total: 0,
			loading: false,
			searching: false,
			searchQuery: undefined,
			page: 0,
			size: 10,
			distributors: [],
			distributorMap: [],
			parentCustomerId: -1,
			isActive,
			activeTab: isActive ? "hakedisTab" : "creditPurchaseTab",
			activeUpperTab: 'generalInfo',
			isGrouped: false,
			countSavedCustomer: null,
			creditPurchase: null,

		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.getDistributors = this.getDistributors.bind(this);
		this.onChangeCheck = this.onChangeCheck.bind(this);
	}

	componentDidMount() {
		this.getDistributors();
		this.getCountCustomer();
	}
	componentWillMount() {
		this.getCreditPurchase();
	}
	componentWillUnmount() {
		const currentPath = window.location.pathname;

		if (!currentPath.includes("progresspayment")) {
			localStorage.removeItem("isActive");
		}
	}
	getDistributors() {
		let self = this;
		let params = {
			url: `/progresspayment/getDistributors`,
			method: "post"
		};
		request(params)
				.then(function (response) {
					let {distributors, allDistributors} = response.data;
					let distributorMap = allDistributors.reduce(function (map, obj) {
						map[obj.recordId] = obj.customerName;
						return map;
					}, {});
					console.log(distributorMap);

					distributors = distributors.map(distributor => ({
						value: distributor.recordId,
						label: distributor.customerName
					}));
					distributors.unshift({value: null, label: 'Tümü'});
					self.setState({distributors, distributorMap});
				}).catch(function (error) {
			showAxiosError(error);
		});
	}

	getParentCustomerId(searchQuery) {
		let res = searchQuery.split('&');
		let item = res.find(item => item.includes('parentCustomerId'));
		let parentCustomerId = (item ? item.split('=')[1] : -1);
		return parentCustomerId;
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = (this.state.isGrouped ? '' : accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=purchaseDate,desc');
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;

		let params = {
			url: '/progresspayment/fetch/' + this.getParentCustomerId(searchQuery) + '/' + this.state.isGrouped + '?page=' + page + '&size=' + size + searchQuery + sortStr,
			method: "get",
		};
		self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
		self.props.reload(true);
		request(params)
				.then(function (response) {
					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						content: response.data.content,
						loading: false,
						searching: false
					});
					self.props.reload(false);
				}).catch(function (error) {
			self.setState({loading: false, searching: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}
	handleTabChange = (tab) => {
		this.setState({ activeTab: tab });
	};

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	getCreditAction(creditAction) {
		if (creditAction === 0) {
			return ("Sıfır Başlangıç");
		} else if (creditAction === 1) {
			return ("Satın Alma");
		} else if (creditAction === 2) {
			return ("Devir (Giriş)");
		} else if (creditAction === 3) {
			return ("Hediye")
		} else if (creditAction === 4) {
			return ("Devir (Çıkış)")
		} else if (creditAction === 5) {
			return ("Transfer")
		} else if (creditAction === 6) {
			return ("Kredi Havuzuna Katılma")
		} else if (creditAction === 7) {
			return ("Kredi Havuzundan Ayrılma")
		} else if (creditAction === 8) {
			return ("Kredi Silme")
		} else {
			return ("Hareket Yok");
		}
	}

	getUnitType(unit) {
		if (unit === 1) {
			return ("Kontör Adeti");
		} else if (unit === 2) {
			return (defterUnitName(EntegratorConf.identifier));
		} else if (unit === 3) {
			return ("e-Arşiv Kasa")
		} else {
			return ("Birim Yok");
		}
	}

	unitTypeList() {
		return [
			{value: "", label: 'Tümü'},
			{value: "1", label: "Kontör"},
			{value: "2", label: defterUnitName(EntegratorConf.identifier)},
			{value: "3", label: "Arşiv Kasa"}
		]
	}

	actionTypeList() {
		return [
			{value: "", label: 'Tümü'},
			{value: "1", label: "Satın Alma"},
			{value: "3", label: "Hediye"},
			{value: "5", label: "Transfer"}
		]
	}

	onChangeCheck() {
		this.setState({isGrouped: !this.state.isGrouped}, () => {
			this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size)
		});
	}

	convertToDate(data) {
		let result = {
			filter: "day",
			list: []
		};
		for (const value in data) {
			const date = value.split("-");
			let newData = {
				year: date[0],
				mount: date[1],
				day: date[2],
				value: data[value],
			};
			result.list.push(newData);
		}
		return result;
	}

	getCountCustomer() {
		let params = {
			url: `/customer/fetchByCreateDate`,
			method: "get"

		};
		request(params).then(response => {
			let convertedData = this.convertToDate(response.data);
			this.setState({countSavedCustomer: convertedData});
		});
	}

	getCreditPurchase() {
		let params = {
			url: `/credit/getCreditByDate`,
			method: "post"
		};
		request(params).then(response => {
			let convertedData = this.convertToDate(response.data);
			this.setState({creditPurchase: convertedData});
		});
	}

	fillLabel(data) {
		let labels = [];
		if (data == null || data.list.length <= 0)
			return;
		if (data.filter === "day") {
			for (const property in data.list) {
				labels.push(data.list[property].year + "-" + data.list[property].mount + "-" + data.list[property].day);
			}
		}
		if (data.filter === "mount") {
			for (const property in data.list) {
				const label = data.list[property].year + "-" + data.list[property].mount;
				if (!(labels.includes(label)))
					labels.push(label);
			}
		}
		if (data.filter === "year") {
			for (const property in data.list) {
				const label = data.list[property].year;
				if (!(labels.includes(label)))
					labels.push(label);
			}
		}
		return labels;
	}

	fillValueOfLabel(data, labels) {
		let values = [];
		if (data == null || data.list.length <= 0)
			return;

		if (data.filter === "day") {
			for (const property in data.list) {
				values.push(data.list[property].value);
			}
		}
		if (data.filter === "mount" || data.filter === "year") {
			let oldLabel = "";
			let value = 0;
			for (const property in data.list) {
				let label = "";
				(data.filter === "mount") ?
						label = data.list[property].year + "-" + data.list[property].mount
						:
						label = data.list[property].year

				if (oldLabel === label) {
					value += data.list[property].value;
				}
				if (oldLabel === "") {
					oldLabel = label;
					value = data.list[property].value;
				}
				if (oldLabel !== label) {
					values.push(value);
					oldLabel = label;
					value = data.list[property].value;
				}
				if (parseInt(property, 10) === (data.list.length - 1)) {
					values.push(value);
				}
			}
		}
		return values;
	}

	changeFilterType(event, state) {
		let savedCustomerState = this.state.countSavedCustomer;
		savedCustomerState.filter = event.target.value;

		let creditPurchaseState = this.state.creditPurchase;
		creditPurchaseState.filter = event.target.value;

		this.setState({
			countSavedCustomer: savedCustomerState,
			creditPurchase: creditPurchaseState
		});
	}

	render() {
		const defaultHeaders = headerContent.progressPaymentContent;
		const defaultHeadersPaytr = headerContent.progressPaymentPaytrContent;
		const defaultheadersHakedis = headerContent.progressPaymentHakedisContent;
		const defaultHeaderDistributor = headerContent.distributorContent;

		const columns = [
			{
				Header: <div style={{textAlign: 'center'}}>VKN/TCKN</div>,
				accessor: "customer.vknTckn",
				Cell: row => (<div style={{textAlign: "center"}}>
					{row.customer.vknTckn}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>Bayi</div>,
				accessor: "customer.parentCustomerId",
				Cell: row => (<div style={{textAlign: "center"}}>
					{<TextOverFlowTooltip text={this.state.distributorMap[row.customer.parentCustomerId]} maxLength={20}/>}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>Ünvan</div>,
				accessor: "customer.customerName",
				Cell: row => (<div style={{textAlign: "center"}}>
					{<TextOverFlowTooltip text={row.customer.customerName} maxLength={20}/>}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>İşlem Türü</div>,
				accessor: "creditAction",
				Cell: row => (<div style={{textAlign: "center"}}>
					{this.getCreditAction(row.creditAction)}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>Birim Türü</div>,
				accessor: "unit",
				Cell: row => (<div style={{textAlign: "center"}}>
					{this.getUnitType(row.unit)}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>{this.state.isGrouped ? 'Toplam Alınan Miktar' : 'Miktar'}</div>,
				accessor: "count",
				Cell: row => (<div style={{textAlign: "center"}}>
					{row.count}
				</div>)
			},
			{
				Header: <div
						style={{textAlign: 'center'}}>{this.state.isGrouped ? 'Son Alınma Zamanı' : 'Alınma Zamanı'}</div>,
				accessor: "purchaseDate",
				Cell: row => (<div style={{textAlign: "center"}}>
					{moment(row.purchaseDate).isValid() ? moment(row.purchaseDate).format("DD-MM-YYYY HH:mm:ss") : ''}
				</div>)
			},
		];

		const fields = [
			{
				label: "Alınma Tarihi (Başlangıç)",
				accessor: "min_purchaseDate",
				type: "datetime",
				operator: ">=",
			},
			{
				label: "Alınma Tarihi (Bitiş)",
				accessor: "max_purchaseDate",
				type: "datetime",
				operator: "<=",
			},
			{
				label: "Bayi",
				accessor: "parentCustomerId",
				type: "select",
				operator: "=",
				selectData: this.state.distributors
			},
			{
				label: "Birim Türü",
				accessor: "unit",
				type: "select",
				operator: "=",
				selectData: this.unitTypeList()
			},
			{
				label: "İşlem Türü",
				accessor: "creditAction",
				type: "select",
				operator: "=",
				selectData: this.actionTypeList()
			},
			{
				label: "VKN/TCKN",
				accessor: "customer.vknTckn",
				type: "text",
				operator: "="
			},
			{
				label: "Ünvan",
				accessor: "customer.customerName",
				type: "text",
				operator: "="
			}
		];

		const customerData = {

			labels: this.fillLabel(this.state.countSavedCustomer),
			datasets: [
				{
					label: 'Kaydedilen Müşteri',
					backgroundColor: 'rgba(255,99,132,0.2)',
					borderColor: 'rgb(255,99,132)',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(255,99,132,0.4)',
					hoverBorderColor: 'rgba(255,99,132,1)',
					type: "line",
					data: this.fillValueOfLabel(this.state.countSavedCustomer)
				}
			]
		};
		const creditPurchaseData = {
			labels: this.fillLabel(this.state.creditPurchase),
			datasets: [
				{
					label: 'Kontör Alımı',
					backgroundColor: 'rgba(255,99,132,0.2)',
					borderColor: 'rgba(255,99,132,1)',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(255,99,132,0.4)',
					hoverBorderColor: 'rgba(255,99,132,1)',
					type: "line",
					data: this.fillValueOfLabel(this.state.creditPurchase)
				}
			]
		};

		const totalDataLabels = () => {
			let labels = [];
			let customerLabels = this.fillLabel(this.state.countSavedCustomer);
			let creditPurchaseLabels = this.fillLabel(this.state.creditPurchase);

			if (customerLabels && creditPurchaseLabels) {
				labels = [...new Set([...customerLabels, ...creditPurchaseLabels])];
			}

			labels.sort((a,b) => {
				a = a.split('-').join('');
				b = b.split('-').join('');
				return a.localeCompare(b);
			});

			return labels;
		};

		return (
				<div className="row baseBackground">
					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
							  name='progressPayment'>

						{!this.state.isActive && (
							<ExcelExporter position="leftSide"
										   sheetName='Bayi_Listesi'
										   title="Bayi Düzenle ve Excel'e Aktar"
										   customExport={true}
										   defaultHeaders={defaultHeaderDistributor}
										   type='progressPaymentDistributor'
										   url='/progresspayment/distributorsExportXls'
										   instantDownload={true}
										   distributors={this.state.distributors}
										   icon='excel'
										   modalHeader='Bayi Listesini Düzenle ve Excele Aktar'
										   impersonateUserRoleId={this.props.impersonateUserRoleId}
							/>
						)}

					</NavBarKS>

					<div className="col-sm-12 satirBasi" style={{padding: '15px'}}>

						{!this.state.isActive && this.state.isActive !== undefined && (
							<>
								<Nav tabs className='nav-tabs-progresspayment'>
									<NavItem className='nav-item-progresspayment'>
										<NavLink
											className={this.state.activeUpperTab === 'generalInfo' ? 'active-progresspayment' : ''}
											onClick={() => {
												this.setState({ activeUpperTab: 'generalInfo' })
											}}
										>
											Genel Bilgiler
										</NavLink>
									</NavItem>

									<NavItem className='nav-item-progresspayment'>
										<NavLink
											className={this.state.activeUpperTab === 'graphics' ? 'active-progresspayment' : ''}
											onClick={() => {
												this.setState({ activeUpperTab: 'graphics' })
											}}
										>
											Grafikler
										</NavLink>
									</NavItem>
								</Nav>

								<Card style={{
									borderWidth: '1px',
									borderStyle: 'solid',
									borderColor: '#5789aaab',
									paddingTop: '20px',
									boxShadow: '0px 20px 10px 4px rgba(39, 39, 39, 0.1)',
									borderRadius: '4px',
									margin: '-1px 0 35px 0'
								}}>
									<TabContent activeTab={this.state.activeUpperTab}>
										<TabPane tabId="generalInfo">
											<Col sm="12" style={{ padding: '10px 15px 25px' }}>
												<div style={{ paddingTop: '20px' }}>
													<ProgressPaymentCard parentCustomerId="-1"
																		 currentUser={this.props.currentUser} />
												</div>
											</Col>
										</TabPane>

										<TabPane tabId="graphics">
											<Col sm='2'>
												<select onChange={(e) => this.changeFilterType(e, "countSavedCustomer")}
														className="form-control" id="exampleFormControlSelect1">
													<option value="day" label="Gün"></option>
													<option value="mount" label="Ay"></option>
													<option value="year" label="Yıl"></option>
												</select>
											</Col>

											<Col sm='12' style={{ height: '200px' }}>
												<Bar data={{
													labels: totalDataLabels(),
													datasets: [
														{
															label: 'Kaydedilen Müşteri',
															backgroundColor: 'rgba(255,99,132,0.2)',
															borderColor: 'rgb(255,99,132)',
															borderWidth: 1,
															hoverBackgroundColor: 'rgba(255,99,132,0.4)',
															hoverBorderColor: 'rgba(255,99,132,1)',
															type: "line",
															data: this.fillValueOfLabel(this.state.countSavedCustomer)
														},
														{
															label: 'Kontör Alımı',
															backgroundColor: 'rgba(22,255,25,0.2)',
															borderColor: 'rgb(38,255,41)',
															borderWidth: 1,
															hoverBackgroundColor: 'rgba(39,255,33,0.4)',
															hoverBorderColor: 'rgb(21,255,32)',
															type: "line",
															data: this.fillValueOfLabel(this.state.creditPurchase)
														}
													],
													redirect: false
												}}
													 width={100}
													 height={200}
													 options={{ maintainAspectRatio: false }} />
											</Col>
										</TabPane>
									</TabContent>
								</Card>
							</>
						)}

						<Nav tabs className="nav-tabs-progresspayment">
							{this.state.isActive ? (
								// Eğer isActive === true ise, SADECE "Hakediş" sekmesi gösterilecek
								<NavItem className="nav-item-progresspayment">
									<NavLink
										className={this.state.activeTab === "hakedisTab" ? "active-progresspayment" : ""}
										onClick={() => this.handleTabChange("hakedisTab")}
									>
										Hakediş
									</NavLink>
								</NavItem>
							) : (
								// Eğer isActive === false ise, TÜM SEKME MENÜLERİ gösterilecek
								<>
									<NavItem className="nav-item-progresspayment">
										<NavLink
											className={this.state.activeTab === "creditPurchaseTab" ? "active-progresspayment" : ""}
											onClick={() => this.handleTabChange("creditPurchaseTab")}
										>
											Yükleme Geçmişi
										</NavLink>
									</NavItem>

									<NavItem className="nav-item-progresspayment">
										<NavLink
											className={this.state.activeTab === "hakedisTab" ? "active-progresspayment" : ""}
											onClick={() => this.handleTabChange("hakedisTab")}
										>
											Hakediş
										</NavLink>
									</NavItem>

									<NavItem className="nav-item-progresspayment">
										<NavLink
											className={this.state.activeTab === "PayTrTab" ? "active-progresspayment" : ""}
											onClick={() => this.handleTabChange("PayTrTab")}
										>
											Tahsilat
										</NavLink>
									</NavItem>

									<NavItem className="nav-item-progresspayment">
										<NavLink
											className={this.state.activeTab === "PayTrBayiTab" ? "active-progresspayment" : ""}
											onClick={() => this.handleTabChange("PayTrBayiTab")}
										>
											Tahsilat Bayi
										</NavLink>
									</NavItem>

									{this.props.currentUser.entegrator &&
										VirtualHost.conf.resourcePrefix &&
										["smart", "kolaysoft", "bymfatura", "aktifdonusum"].includes(VirtualHost.conf.resourcePrefix) && (
											<NavItem className="nav-item-progresspayment">
												<NavLink
													className={this.state.activeTab === "PayTrPrefixTab" ? "active-progresspayment" : ""}
													onClick={() => this.handleTabChange("PayTrPrefixTab")}
												>
													Tahsilat Prefix
												</NavLink>
											</NavItem>
										)}

									{this.props.currentUser.entegrator &&
										VirtualHost.conf.resourcePrefix &&
										["smart", "kolaysoft"].includes(VirtualHost.conf.resourcePrefix) && (
											<NavItem className="nav-item-progresspayment">
												<NavLink
													className={this.state.activeTab === "BayiGenelTab" ? "active-progresspayment" : ""}
													onClick={() => this.handleTabChange("BayiGenelTab")}
												>
													Bayi Genel Listeleme
												</NavLink>
											</NavItem>
										)}

									{this.props.currentUser.entegrator &&
										VirtualHost.conf.resourcePrefix &&
										["smart", "kolaysoft", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix) && (
											<NavItem className="nav-item-progresspayment">
												<NavLink
													className={this.state.activeTab === "TopluKontorBayiTab" ? "active-progresspayment" : ""}
													onClick={() => this.handleTabChange("TopluKontorBayiTab")}
												>
													Toplu Kontör Listeleme
												</NavLink>
											</NavItem>
										)}
								</>
							)}
						</Nav>



						<Card style={{
							borderWidth: '1px',
							borderStyle: 'solid',
							borderColor: '#5789aaab',
							paddingTop: '20px',
							boxShadow: '0px 20px 10px 4px rgba(39, 39, 39, 0.1)',
							borderRadius: '4px',
							margin: '-1px 0 5px 0'
						}}>
							<TabContent activeTab={this.state.activeTab}>
								<TabPane tabId="creditPurchaseTab">
									<Col sm="12">
										<div className="card-body">
											<Row>
												<Col sm='12' style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
													<ExcelExporter position="leftSide"
																   sheetName='Yukleme_Listesi'
																   title="Yükleme Geçmişini Düzenle ve Excel'e Aktar"
																   customExport={true}
																   defaultHeaders={defaultHeaders}
																   type='progressPayment'
																   url='/progresspayment/exportXls'
																   instantDownload={true}
																   distributors={this.state.distributors}
																   icon='excel'
																   className='excelButton'
																   modalHeader='Yükleme Geçmişi Düzenle ve Excele Aktar'
																   impersonateUserRoleId={this.props.impersonateUserRoleId}/>
													<Label style={{fontSize: "11px", fontWeight: "bold"}} check>
														<Input type="checkbox"
															   id="checkbox"
															   checked={this.state.isGrouped}
															   onChange={(e) => this.onChangeCheck(e)}/>{'   '}
														Müşteri Bazında Toplam Yükleme Geçmişi  Göster
													</Label>
												</Col>
											</Row>
											<div className="row">
												<div className="col-sm-12">
													<div style={{marginTop: '10px', marginBottom: '10px'}} id="PPDetailedContainer">
														<DetailedSearch fields={fields}
																		loading={this.state.searching}
																		onSearch={this.handleSearch} hasContainer="PPDetailedContainer"/>
													</div>
												</div>
											</div>
										</div>
										<div className="card-body">
											<div className=" row">
												<div className="col-sm-12">
													<Table columns={columns}
														   loading={this.state.loading}
														   loadingText="Kayıtlar getiriliyor..."
														   content={this.state.content}
														   total={this.state.total}
														   page={this.state.page}
														   manual={this.state.manual}
														   size={this.state.size}
														   options={["5", "10", "20", "50", "100"]}
														   fetchData={this.fetchData}
													/>
												</div>
											</div>
										</div>
									</Col>
								</TabPane>
								{(this.state.isActive || showProgressPaymentFields(this.props.currentUser.customerId)) && (
									<TabPane tabId="hakedisTab">
										<HakedisList distributors={this.state.distributors} defaultheadersHakedis={defaultheadersHakedis}
													 currentUser={this.props.currentUser}
													 impersonateUserRoleId={this.props.impersonateUserRoleId}
													 isActive={this.state.isActive} />
									</TabPane>
								)}
								<TabPane tabId="PayTrTab">
									<PayTrList defaultHeadersPaytr={defaultHeadersPaytr}
											   isBayi={false}
											   distributors={this.state.distributors}
											   currentUser={this.props.currentUser}
											   impersonateUserRoleId={this.props.impersonateUserRoleId}/>
								</TabPane>
								<TabPane tabId="PayTrBayiTab">
									<PayTrList defaultHeadersPaytr={defaultHeadersPaytr}
											   isBayi={true}
											   distributors={this.state.distributors}
											   currentUser={this.props.currentUser}
											   impersonateUserRoleId={this.props.impersonateUserRoleId}/>
								</TabPane>
								<TabPane tabId="PayTrPrefixTab">
									<PayTrPrefixList defaultHeadersPaytr={defaultHeadersPaytr}
													 distributors={this.state.distributors}
											   		 currentUser={this.props.currentUser}/>
								</TabPane>
								<TabPane tabId="BayiGenelTab">
									<BayiList
										bayiTab={"BayiGenelTab"}
										currentUser={this.props.currentUser}/>
								</TabPane>
								<TabPane tabId="TopluKontorBayiTab">
									<TopluKontorList
										defaultHeadersPaytr={defaultHeadersPaytr}
										currentUser={this.props.currentUser}/>
								</TabPane>
							</TabContent>
						</Card>
					</div>
				</div>
		);
	}
}

export default ProgressPaymentList;
